import { render, staticRenderFns } from "./GeneralSwitchV2.vue?vue&type=template&id=0f5f6ff9&scoped=true&"
import script from "./GeneralSwitchV2.vue?vue&type=script&lang=ts&"
export * from "./GeneralSwitchV2.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralSwitchV2.vue?vue&type=style&index=0&id=0f5f6ff9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f6ff9",
  null
  
)

export default component.exports